<template>
  <div class="animate fadeIn" v-if="page || product">
    <component :is="productTemplate" v-bind="props" v-if="product" />
    <component :is="pageViewTemplate" v-bind="pageProps" v-if="page && pageProps.product" />
  </div>
</template>

<script>
  // import moment from 'moment'
  import PageDetail from '@/components/PageDetail'
  import PageViewDefault from '@/components/templates/pages/default/view'

  export default {
    name: 'PagePage',

    components: {
      PageDetail
    },

    data () {
      return {
        page: null,
        product: null,
        productTemplate: null,
        pageViewTemplate: null,
        props: {},
        pageProps: {}
      }
    },

    created () {
      let id = 0
      if (this.$route.name === 'pages') {
        const path = this.$route.path.substr(1)
        if (isNaN(path)) {
          id = path
        } else {
          return this.$router.push('/')
        }
        // const dt = moment()
        // const targetDt = moment('2020-06-15T09:00:00+0700')
        // if (id === 'donate' && dt.diff(targetDt) > 0) {
        //   this.$router.push(`/limited-education`)
        //   return
        // }
        this.getProduct(id)
          .then(() => {
            this.loadProductTemplate()
          })
          .catch(err => {
            console.log(err)
            this.getPage(id)
          })
      } else {
        id = this.$route.params.id
        this.getPage(id)
      }
    },

    methods: {
      getProduct (sku) {
        return this.$http.get(`products/${sku}`)
          .then(resp => {
            this.product = resp.body
            if (!this.$utils.isProductAvailable(this.product)) {
              this.$router.push('/')
            }
            this.props = {
              product: this.product
            }
          })
      },
      loadProductTemplate () {
        if (this.product.template) {
          try {
            this.productTemplate = require(`@/components/templates/products/${this.product.template}`)
          } catch (err) {
            console.log(err)
            this.productTemplate = require(`@/components/templates/products/base`)
          }
        } else {
          this.productTemplate = require(`@/components/templates/products/base`)
        }
      },
      getPage (id) {
        this.$http.get(`pages/${id}`)
          .then(resp => {
            this.page = resp.body
            try {
              this.page.data = JSON.parse(this.page.data)
            } catch (err) {
              console.log(err)
              this.page.data = {
                body: ''
              }
            }
            if (!this.page.data.total_product_price) {
              this.page.data.total_product_price = 0
            }
            if (!this.page.data.total_product_quantity) {
              this.page.data.total_product_quantity = 0
            }
          })
          .then(() => {
            if (this.page.ref_obj_type === 'product' && this.page.ref_obj_id) {
              return this.$http.get(`products/${this.page.ref_obj_id}`)
                .then(resp => {
                  const product = resp.body
                  product.originalPrice = product.price

                  if (product.template) {
                    try {
                      this.pageViewTemplate = require(`@/components/templates/pages/${product.template}/view`)
                    } catch (err) {
                      console.log(err)
                      this.pageViewTemplate = PageViewDefault
                    }
                  } else {
                    this.pageViewTemplate = PageViewDefault
                  }

                  this.pageProps = {
                    page: this.page,
                    product: product
                  }
                })
            }
          })
          .catch(err => {
            console.log('xxxxx', err)
            // this.$router.push('/')
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PagePage.vue?036dd62f